import { Auth } from 'aws-amplify';
import createModuleLogger, { Bindings, createLogger } from '@garner-health/logging';

const sessionId = crypto.randomUUID();

const log = createLogger({
  logLevel: 'info',
  logDestination: {
    path: '/api/logs',
    async lazyBindings(): Promise<Bindings> {
      try {
        const session = await Auth.currentSession();
        const clientId = session.getIdToken().payload['custom:client_id'];
        return { clientId };
      } catch (err) {
        // Can't log here because it would create a potentially infinite loop of logging errors
        return {};
      }
    },
  },
}).child({
  component: 'eligibility-portal',
  strSessionId: sessionId,
  strAppVersion: GARNER_VERSION,
  strBuildNumber: GARNER_BUILD_NUMBER,
  strCommitSha: GARNER_COMMIT_SHA,
});

if (!['development', 'test'].includes(process.env.NODE_ENV!)) {
  const externalLog = log.child({ module: 'eligibility-portal-ui-external' });
  Object.assign(console, {
    log: externalLog.info.bind(externalLog),
    info: externalLog.info.bind(externalLog),
    warn: externalLog.warn.bind(externalLog),
    error: externalLog.error.bind(externalLog),
    fatal: externalLog.fatal.bind(externalLog),
    trace: externalLog.trace.bind(externalLog),
    debug: externalLog.debug.bind(externalLog),
  });
}

export default function logger(module: string, bindings?: Omit<Bindings, 'module'>) {
  return createModuleLogger(module, { log }, bindings as Bindings & { module: never });
}
